<template>
   <div>
      <div class="mt-4 pt-4">
         <h1>Scanner</h1>
         <div class="mt-4">
            <div class="row">
               <div class="col-12">
                  <div class="card">
                     <div class="card-header mb-4">
                        <div class="position-relative m-4">
                           <div class="progress" style="height: 1px;">
                              <div class="progress-bar" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                           </div>
                           <button type="button" class="position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">1</button>
                           <button type="button" class="position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">2</button>
                           <button type="button" class="position-absolute top-0 start-100 translate-middle btn btn-sm btn-primary rounded-pill" style="width: 2rem; height:2rem;">3</button>
                        </div>
                     </div>
                     <div class="card-body">
                        <div class="row">
                         <div class="col-md-12">
                             <h3>Scan options</h3>
                             <div class="card">
                                 <div class="card-body">
                                     <div class="form-check">
                                         <label class="form-check-label">
                                             <input class="form-check-input" type="checkbox" value="true" v-model="passive">
                                             <span class="form-check-sign"></span>
                                             <strong>Passive Only Scan</strong>
                                             <ul>
                                                 <li>Directory and Files Search</li>
                                                 <li>Port Scan</li>
                                                 <li>Header Scan</li>
                                                 <li>SSL Scan</li>
                                                 <li>DNS Scan</li>
                                             </ul>
                                         </label>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <div class="col-md-12 mt-4">
                           <router-link :to="'/' + this.$route.params.org_id + '/scan/' + this.$route.params.prod_id + '/step/2'" class="btn btn-lg btn-secondary text-light ps-4 pe-4 me-4">Back <i class="fas fa-angle-left"></i></router-link>
                             <button class="btn btn-lg btn-info text-light" v-on:click="scan()" v-if="passive">Start Scan</button>
                         </div>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
  export default {
      components: {
      },
      data () {
          return {
              passive: false,
              auth: false
          }
      },
      methods: {
          scan() {
            const me = this;
            // this.$router.push('scan/log');
            this.$axios.get(this.$server + 'organisation/'+ me.$route.params.org_id +'/projects/' + me.$route.params.prod_id + '/scan', {
                params: {
                    passive : me.passive,
                    auth : me.auth,
                }
            }).then(res => {
                var r = res.data;
                if (r.success) {
                    me.$swal({
                      title: r.message
                    });
                    me.init();
                } else {
                    me.$swal({
                      title: r.message,
                      icon: 'error'
                    });
                }
            });
          }
      }
  }
</script>